module.exports = __webpack_public_path__ + "media/images/story/top/step1_image-6bbac0991fd1b4bbc41248b4558d3b56.png";